import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import quiControleQuoiImage from "../../../assets/smarthome/quiControleQuoi.png";
import quiControleQuoiMobileImage from "../../../assets/smarthome/quiControleQuoiMobile.png";
import MultilogementImage from "../../../assets/smarthome/Multilogement.jpg";
import textContentSmarthomeContactUsSection from "../ui/textContent-smarthome-contactUsSection";

export default function UsersRolesSection(props) {
  const { textContent, language } = { ...props };
  const isMobile = useSelector((state) => state.screen.isMobile);
  const screenWidth = useSelector((state) => state.screen.screenWidth);

  return (
    <section className="container security-section">
      <div className={`container-small ${isMobile ? "smart-mobile" : ""}`}>
        <h1 className="title-gradient">
          {textContent.userRolesSection.title[language]}
        </h1>
        <h2>{textContent.userRolesSection.subtitle[language]}</h2>
        <p>{textContent.userRolesSection.description[language]}</p>
      </div>
      <div className={`users-and-roles-image ${isMobile ? "mobile" : ""}`}>
        <img
          src={isMobile ? quiControleQuoiMobileImage : quiControleQuoiImage}
        />
      </div>
      {isMobile ? (
        <div className="container-empty-small" />
      ) : (
        <div className="container-empty-small" />
      )}
      <div className={`users-and-roles ${isMobile ? "mobile" : ""}`}>
        <div className="multiHouse-image">
          <img src={MultilogementImage} aria-hidden="true" />
        </div>
        <div className={`users-and-roles-text ${isMobile ? "mobile" : ""}`}>
          <h2 className="h2-bold">
            {textContent.userRolesSection.feature.multiHouses.title[language]}
          </h2>
          <p>
            {
              textContent.userRolesSection.feature.multiHouses.description[
                language
              ]
            }
          </p>
          {!isMobile ? (
            <div>
              <div className="container-empty-extra-small" />

              <a
                href="https://www.polynhome.io/nous-contacter/"
                className="learn-more-button"
              >
                {
                  textContentSmarthomeContactUsSection.contactUsSection.title[
                    language
                  ]
                }
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
